(function () {
  window.__athosATCContext = null;

  const waitForQuickAddModal = () => {
    const QuickAddModalClass = customElements.get("quick-add-modal");
    if (!QuickAddModalClass) {
      setTimeout(waitForQuickAddModal, 100);
      return;
    }

    const originalShow = QuickAddModalClass.prototype.show;
    QuickAddModalClass.prototype.show = function (opener) {
      const carouselHandler = opener?.closest("searchspring-carousel-handler, cart-carousel");
      const crossSell = opener?.closest("searchspring-cross-sell");
      const collection = opener?.closest("searchspring-collection");

      if (carouselHandler && carouselHandler.modules?.beacon) {
        window.__athosATCContext = {
          type: "recommendations",
          tag: carouselHandler.profileTag,
          responseId: carouselHandler.modules.beacon.profileEventId,
        };
      } else if (crossSell && crossSell.modules?.beacon) {
        window.__athosATCContext = {
          type: "recommendations",
          tag: crossSell.profileTag,
          responseId: crossSell.modules.beacon.profileEventId,
        };
      } else if (collection && collection.modules?.beacon) {
        const isSearch = window.location.href.includes("/search");
        window.__athosATCContext = {
          type: isSearch ? "search" : "category",
          responseId: collection.modules.beacon.profileEventId,
        };
      } else {
        window.__athosATCContext = null;
      }

      // Call original show
      return originalShow.call(this, opener);
    };
  };

  waitForQuickAddModal();

  // Listen for cart:updated custom event
  document.addEventListener("cart:updated", (event) => {
    if (!window.__athosATCContext) return;

    const ctx = window.__athosATCContext;
    if (!ctx.responseId) return;

    const cartData = event.detail?.cartData;
    let variantId = null;

    // cartData from product-form has different structure
    if (cartData?.id) {
      // Direct add to cart response - has the added item
      variantId = String(cartData.id);
    } else if (cartData?.items?.length) {
      variantId = String(cartData.items[cartData.items.length - 1].id);
    }

    if (!variantId) return;

    const beaconSource =
      document.querySelector("searchspring-carousel-handler")?.modules?.beacon ||
      document.querySelector("searchspring-cross-sell")?.modules?.beacon ||
      document.querySelector("searchspring-collection")?.modules?.beacon;

    if (!beaconSource) return;

    const product = { uid: variantId, id: variantId };

    if (ctx.type === "recommendations") {
      beaconSource.sendRecommendationsAddToCart(ctx.responseId, ctx.tag, product, 1, 0);
    } else if (ctx.type === "search") {
      beaconSource.sendSearchAddToCart(ctx.responseId, product, 1, 0);
    } else if (ctx.type === "category") {
      beaconSource.sendCategoryAddToCart(ctx.responseId, product, 1, 0);
    }

    window.__athosATCContext = null;
  });
})();
